'use client'
import type { ReactNode } from 'react'
import { cx } from '../utils'

export function Progress({ value, max = 100 }: { value: number; max?: number }) {
  const pct = Math.min((value / max) * 100, 100)
  return (
    <div className="h-2 w-full overflow-hidden rounded-full bg-sunken">
      <div
        className="h-full rounded-full bg-accent-fill transition-all duration-300"
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
